import { makeAutoObservable } from "mobx";

class AnalyticsStore {
  overall = {
    selectedItemBestAndWorst: {
      id: "0",
      name: "Across Categories",
    },
    familyMembers: [],
    portfolioAssetClass: [],
    familyAssetAllocationOverTime: [],
    performerLoading: true,
    assetAllocationLoading: true,
    investmentLoading: true,
    amcExposureLoading: true,
    mfExposureLoading: true,
    portfolioAllocationLoading: true,
    portfolioAgeingLoading: true,
    bestPerformerLoading: true,
    worstPerformerLoading: true,
    portfolioAgeing: [],
    investmentValue: [],
    bestPerformer: [],
    worstPerformer: [],
    amcExposure: [],
    categoryExposure: [],
    portfolioAllocation: [],
    allAssetClassesData: [],
    userId: null,
    isPrimary: false,
    portfolioAgeingTableHeight: 3,
  };

  equity = {
    selectedItemBestAndWorst: {
      id: "",
      name: "Across Categories",
    },
    bestPerformerLoading: true,
    worstPerformerLoading: true,
    bestPerformer: [],
    worstPerformer: [],

    marketCapLoading: true,
    sectoralAllocationLoading: true,
    marketCapAllocation: [],
    sectoralAllocation: [],

    stockConcentrationLoading: true,
    stockConcentration: [],

    marketCapSelectedOption: {
      id: 1,
      value: "Direct Equity + MF Equity",
      apiKey: "all",
    },
    sectoralAllocationSelectedOption: {
      id: 1,
      value: "Direct Equity + MF Equity",
      apiKey: "all",
    },
    stockConcentrationSelectedOption: {
      id: 1,
      value: "Direct Equity + MF Equity",
      apiKey: "all",
    },

    marketCapDropdownVisibility: false,
  };

  fixedIncome = {
    selectedItemBestAndWorst: {
      id: "",
      name: "Across Categories",
    },

    bestPerformerLoading: true,
    worstPerformerLoading: true,
    bestPerformer: [],
    worstPerformer: [],

    creditScoreSelectedOption: {
      id: 1,
      value: "Bonds + MF Debt",
      apiKey: "all",
    },
    creditScore: [],
    creditScoreLoading: false,

    issuerExposure: [],
    issuerExposureLoading: false,
    issuerExposureSelectedOption: {
      id: 1,
      value: "Bonds + MF Debt",
      apiKey: "all",
    },
    durationAnalysis: [],
  };

  constructor() {
    makeAutoObservable(this);
  }

  setOverall(obj) {
    this.overall = obj;
  }

  setEquity(obj) {
    this.equity = obj;
  }

  setFixedIncome(obj) {
    this.fixedIncome = obj;
  }

  setAnalyticsStoreToIntialState() {
    this.overall = {
      familyMembers: [],
      portfolioAssetClass: [],
      familyAssetAllocationOverTime: [],
      portfolioAgeing: [],
      investmentValue: [],
      bestPerformer: [],
      worstPerformer: [],
    };

    this.equity = {
      selectedItemBestAndWorst: {
        id: "",
        name: "Across Categories",
      },
      bestPerformerLoading: false,
      worstPerformerLoading: false,
      bestPerformer: [],
      worstPerformer: [],

      marketCapLoading: false,
      sectoralAllocationLoading: false,
      marketCapAllocation: [],
      sectoralAllocation: [],

      stockConcentrationLoading: false,
      stockConcentration: [],

      marketCapSelectedOption: {},
      sectoralAllocationSelectedOption: {},
      stockConcentrationSelectedOption: {},
    };

    this.fixedIncome = {
      selectedItemBestAndWorst: {
        id: "",
        name: "Across Categories",
      },

      bestPerformerLoading: false,
      worstPerformerLoading: false,
      bestPerformer: [],
      worstPerformer: [],

      creditScoreSelectedOption: {
        id: 1,
        value: "Bonds + MF Debt",
        apiKey: "all",
      },
      creditScore: [],
      creditScoreLoading: false,

      issuerExposure: [],
      issuerExposureLoading: false,
      issuerExposureSelectedOption: {
        id: 1,
        value: "Bonds + MF Debt",
        apiKey: "all",
      },
    };
  }
}

const Analytics = new AnalyticsStore();

export default Analytics;
